import React from 'react'
import Graph from '../components/Graph/Graph'
import Admin from '../components/Admin/Admin'

export default function AdminPage({user}) {
    if(user!==null){
    return (
        <>
        {
        user.email === "vqpoint@hotmail.com"
        ?
        <div>
            <Admin currentUser={user}/> 
            <Graph route={"admin"}/>
        </div>
        :
        <div className="white">Sign In using admin account</div>
        }
        </>
    );
    }
    else{
        return <div className="white">Please Sign in to access this page</div>
    }
}
